import React from 'react'
import RatingStars from 'src/widgets/RatingStars/RatingStars'

export default function OfficerTemplate({
  viewOnly = false,
  ratingData,
  onChange,
  submittedRating,
}) {
  const getTotalRating = () => {
    const {
      work_output,
      work_quality,
      emotional_stability,
      tolerance,
      reliability,
      judgement,
      written_expression,
      clarity_of_thoughts,
      ability,
      supervision_and_Guidance,
      relation_with_Superiors,
    } = ratingData

    let total =
      parseInt(work_output) +
      parseInt(work_quality) +
      parseInt(emotional_stability) +
      parseInt(tolerance) +
      parseInt(reliability) +
      parseInt(judgement) +
      parseInt(written_expression) +
      parseInt(clarity_of_thoughts) +
      parseInt(ability) +
      parseInt(supervision_and_Guidance) +
      parseInt(relation_with_Superiors)
    return total
  }

  const getSubmittedRating = () => {
    const {
      work_output,
      work_quality,
      emotional_stability,
      tolerance,
      reliability,
      judgement,
      written_expression,
      clarity_of_thoughts,
      ability,
      supervision_and_Guidance,
      relation_with_Superiors,
    } = submittedRating

    let total =
      parseInt(work_output) +
      parseInt(work_quality) +
      parseInt(emotional_stability) +
      parseInt(tolerance) +
      parseInt(reliability) +
      parseInt(judgement) +
      parseInt(written_expression) +
      parseInt(clarity_of_thoughts) +
      parseInt(ability) +
      parseInt(supervision_and_Guidance) +
      parseInt(relation_with_Superiors)
    return total
  }

  return (
    <>
      <div style={{ padding: '10px' }}>
        <table
          width="100%"
          className="table table-striped"
          style={{
            marginTop: '16px',
            borderCollapse: 'collapse',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          <tbody>
            <tr>
              <th style={{ width: '70px' }}>Misc. Aspects</th>
              <th style={{ width: '24px' }}>Submitted Rating</th>
              <th style={{ width: '24px' }}>RATING FACTORS</th>
              <th style={{ width: '6px' }}>RATING</th>
            </tr>
            <tr>
              <td>
                <strong>Work Output</strong>
              </td>
              <td>{submittedRating.work_output}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.work_output}
                  onChange={(value) => onChange('work_output', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.work_output}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Work Quality</strong>
              </td>
              <td>{submittedRating.work_quality}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.work_quality}
                  onChange={(value) => onChange('work_quality', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.work_quality}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Emotional Stability in Pressure</strong>
              </td>
              <td>{submittedRating.emotional_stability}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.emotional_stability}
                  onChange={(value) => onChange('emotional_stability', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.emotional_stability}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Tolerance in Ambiguity</strong>
              </td>
              <td>{submittedRating.tolerance}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.tolerance}
                  onChange={(value) => onChange('tolerance', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.tolerance}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Reliability under pressure</strong>
              </td>
              <td>{submittedRating.reliability}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.reliability}
                  onChange={(value) => onChange('reliability', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.reliability}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Workload VS Task Management</strong>
              </td>
              <td>{submittedRating.judgement}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.judgement}
                  onChange={(value) => onChange('judgement', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.judgement}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Written Expression</strong>
              </td>
              <td>{submittedRating.written_expression}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.written_expression}
                  onChange={(value) => onChange('written_expression', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.written_expression}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Clarity of thoughts</strong>
              </td>
              <td>{submittedRating.clarity_of_thoughts}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.clarity_of_thoughts}
                  onChange={(value) => onChange('clarity_of_thoughts', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.clarity_of_thoughts}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Ability to Give & Take task</strong>
              </td>
              <td>{submittedRating.ability}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.ability}
                  onChange={(value) => onChange('ability', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.ability}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Supervision & Guidance</strong>
              </td>
              <td>{submittedRating.supervision_and_Guidance}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.supervision_and_Guidance}
                  onChange={(value) => onChange('supervision_and_Guidance', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.supervision_and_Guidance}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <strong>Relation with Superiors, Colleagues & Subordinates</strong>
              </td>
              <td>{submittedRating.relation_with_Superiors}/10</td>
              <td>
                <RatingStars
                  count={10}
                  value={ratingData.relation_with_Superiors}
                  onChange={(value) => onChange('relation_with_Superiors', value)}
                  viewOnly={viewOnly}
                />
              </td>
              <td>
                <b style={{ color: 'blue' }} readOnly={viewOnly}>
                  {ratingData !== null ? `${ratingData.relation_with_Superiors}/10` : ''}
                </b>
              </td>
            </tr>
            <tr>
              <td>
                <b readOnly={viewOnly}>Overall Performance:</b>
              </td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getSubmittedRating()} / 110</td>
              <td></td>
              <td style={{ color: 'green', fontWeight: 'bold' }}> {getTotalRating()} / 110</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  )
}
